module.exports = __webpack_public_path__ + "static/media/bg-06.71ef0cb7.png";